module.exports = __webpack_public_path__ + "static/img/brand-third-3.7bfbacac.png";